module.exports = __webpack_public_path__ + "static/img/pitch_green.9d78033.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_green.png
// module id = t70D
// module chunks = 79